import { render, staticRenderFns } from "./TemplatesTable.vue?vue&type=template&id=785a9d9b&"
import script from "./TemplatesTable.vue?vue&type=script&lang=ts&"
export * from "./TemplatesTable.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesTable.vue?vue&type=style&index=0&id=785a9d9b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('785a9d9b')) {
      api.createRecord('785a9d9b', component.options)
    } else {
      api.reload('785a9d9b', component.options)
    }
    module.hot.accept("./TemplatesTable.vue?vue&type=template&id=785a9d9b&", function () {
      api.rerender('785a9d9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_Template/TemplatesTable.vue"
export default component.exports